import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import RenderNestedValues from "./RenderNestedValues";
import RenderPrimitiveValues from "./RenderPrimitiveValues";
import { TextField } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    height: 425,
    justifyContent: "flex-start",
  },
}));

const FieldGenerator = ({ sideBarData, selectedItem, handleChangeData }) => {
  const classes = useStyles();
  const convertedList = Object.keys(sideBarData).reduce((acc, key) => {
    if (key !== "description") acc.push([key, sideBarData[key]]);
    return acc;
  }, []);

  const { description } = sideBarData;

  return (
    <div className={classes.root}>
      <p>{selectedItem}</p>
      <TextField
        multiline={true}
        variant="outlined"
        value={description?.value || ""}
        label="Description"
        onChange={(e) =>
          handleChangeData(
            { ...e, target: { ...e.target, name: "value", type: "text" } },
            description.id
          )
        }
      />
      {convertedList.map((item) => {
        const [key, value] = item;

        if (typeof value === "object") {
          const nestedItem = Object.entries(value);
          return (
            <div key={key}>
              <RenderNestedValues
                handleChangeData={handleChangeData}
                blockTitle={key}
                item={nestedItem}
              />
            </div>
          );
        } else {
          return (
            <div key={key}>
              <RenderPrimitiveValues
                item={item}
                handleChangeData={handleChangeData}
                objectId={convertedList[convertedList.length - 1][1]}
              />
            </div>
          );
        }
      })}
    </div>
  );
};

export default FieldGenerator;
